// uiarc: input (https://uiarc.dev/r/input.json) alan gövdesi. Etiket/yardım/hata satırı `field.tsx`te
// (`Field`, `FieldLabel`, `FieldDescription`, `FieldError`). Odak yalnız kenarlık rengiyle yanıt verir (halka yok),
// alan boyutu değişmez; üzerine gelince kenarlık ön plan rengine döner (geçersiz/devre dışı hariç).
import * as React from 'react'
import { Input as InputPrimitive } from '@base-ui/react/input'
import { cn } from '@/lib/utils'

function Input({ className, type, ...props }: React.ComponentProps<'input'>) {
  return (
    <InputPrimitive
      type={type}
      data-slot="input"
      className={cn(
        'border-border-strong bg-surface text-foreground placeholder:text-text-muted rounded-control leading-body ease-standard h-(--control-height-md) w-full min-w-0 border px-3 text-sm tracking-(--tracking-body) transition-[border-color,background-color] duration-(--duration-fast) outline-none motion-reduce:transition-none',
        'file:text-foreground file:mr-3 file:inline-flex file:h-full file:border-0 file:bg-transparent file:text-sm file:font-medium',
        'not-disabled:not-aria-invalid:hover:border-foreground focus-visible:border-foreground aria-invalid:border-danger',
        'disabled:bg-surface-muted disabled:cursor-not-allowed disabled:opacity-50',
        className,
      )}
      {...props}
    />
  )
}

export { Input }
